import { XIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import { Spinner } from '@/shared/components/ui/spinner'

import { useRejectAnchorFamily } from '../../lib/useRejectAnchorFamily'
import { useApprovalPageContext } from '../ApprovalPageProvider'

export default function AnchorFamilyRejectButton({ id }: { id: string }) {
	const { t } = useTranslation()

	const { handleRejectAnchorFamily, isPending } = useRejectAnchorFamily()
	const { isMutationPending } = useApprovalPageContext()

	return (
		<Button
			disabled={isMutationPending}
			data-testid='reject-button'
			variant='destructive'
			size='sm'
			onClick={() => handleRejectAnchorFamily(id)}
		>
			{isPending ? <Spinner /> : <XIcon />}
			{t('app.reject')}
		</Button>
	)
}
